<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="处理状态">
              <j-dict-select-tag
                v-model="queryParam.isDeal"
                placeholder="请选择处理状态"
                dictCode="deal_prize"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left;overflow: hidden;"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <!--<div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>-->

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        :columns="columns"
        size="middle"
        :dataSource="dataSource"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        rowKey="id"
        :scroll="{ x: 1500 }"
        ref="table"
        bordered
        :pagination="ipagination"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <!--<a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>-->
        </span>
      </a-table>
    </div>

    <exchange-prize-modal
      ref="modalForm"
      :dataSource="dataSource"
      @ok="modalFormOk"
    ></exchange-prize-modal>
  </a-card>
</template>

<script>
import { getAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import ExchangePrizeModal from './modules/ExchangePrizeModal';

export default {
  name: 'ExchangePrize',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JInput,
    ExchangePrizeModal
  },
  data() {
    return {
      description: '奖品兑换页面',
      queryParam: {},
      // 表头
      columns: [
        {
          title: '兑奖人ID',
          align: 'center',
          dataIndex: 'openId',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 10) + '...'
              : text;
          }
        },
        {
          title: '兑奖人姓名',
          align: 'center',
          dataIndex: 'name'
        },
        {
          title: '兑奖人电话',
          align: 'center',
          dataIndex: 'phone'
        },
        {
          title: '兑奖人地址',
          align: 'center',
          dataIndex: 'address',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 8
              ? text.substr(0, 8) + '...'
              : text;
          }
        },
        {
          title: '奖品名称',
          align: 'center',
          dataIndex: 'prizeName',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 8
              ? text.substr(0, 8) + '...'
              : text;
          }
        },
        {
          title: '奖品id',
          align: 'center',
          dataIndex: 'prizeId',
          customRender: function(text) {
            return !text
              ? ''
              : text.length > 8
              ? text.substr(0, 8) + '...'
              : text;
          }
        },
        {
          title: '发起兑奖时间',
          align: 'center',
          dataIndex: 'createTime'
          /*customRender:function (text) {
              return !text?"":(text.length>10?text.substr(0,10):text)
            }*/
        },
        {
          title: '处理状态',
          align: 'center',
          dataIndex: 'isDeal_dictText'
        },
        {
          width: 170,
          title: '处理时间',
          align: 'center',
          dataIndex: 'dealTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/exchange/prize/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/exchange/prize/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/exchange/prize/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_MARKETING + '/integral/config/exportXls'
      },
      dictOptions: {}
    };
  },
  computed: {},
  created() {},
  methods: {
    loadData2() {
      this.dataSource = [];
      getAction(this.url.list, this.queryParam).then(res => {
        if (res.success) {
          this.dataSource = res.result.records;
          console.log('dataSource', this.dataSource);
        }
      });
    },
    initDictConfig() {}
  }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
